import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { createGtag } from "vue-gtag";

const vuetify = createVuetify({
  components,
  directives,
});
const app = createApp(App);

createGtag({
  tagId: process.env.VUE_APP_GOOGLE_ANALYTICS_ID,
  config: {
    anonymize_ip: true,
  },
});
app.use(store);
app.use(router);
app.use(vuetify);

app.mount("#app");
